// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1DEMn","left":"_2imY9","right":"_3B3TQ","textarea":"_3_8Kv"};